// Add your custom JS here.
jQuery(document).ready(function($) {
	$(window).on('scroll', function() {
		var scrollTop = $(this).scrollTop();

		// Sticky after 1px
		if (scrollTop > 1) {  
			$('.p-header').addClass('sticky');
		} else {
			$('.p-header').removeClass('sticky');
		}

		// Small after 200px
		if (scrollTop > 200) {
			$('.p-header').addClass('small');
		} else {
			$('.p-header').removeClass('small');
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('a.search-filter-reset');

  links.forEach(function (link) {
	link.classList.add('large-btn', 'light-btn', 'small-btn', 'white-hover');
  });
});



document.addEventListener('DOMContentLoaded', function () {
  // We’ll use event delegation so this survives any AJAX DOM swaps.
  function getFakeSelect() {
	return document.getElementById('sf-fake-sort');
  }

  function getRealSelect() {
	return document.querySelector('select[name="_sf_sort_order[]"]');
  }

  // --- Initial sync from URL -> fake -> real ---
  (function syncFromURL() {
	var fake = getFakeSelect();
	if (!fake) return;

	try {
	  var url      = new URL(window.location.href);
	  var current  = url.searchParams.get('sort_order') || '';
	  var options  = Array.prototype.map.call(fake.options, function (o) { return o.value; });

	  if (options.indexOf(current) !== -1) {
		fake.value = current;
	  } else {
		fake.value = '';
	  }

	  // Also sync the real select so S&F form submissions keep the same sort
	  var real = getRealSelect();
	  if (real) {
		real.value = fake.value;
	  }
	} catch (e) {
	  // ignore
	}
  })();

  // --- When fake select changes, update real + URL and reload ---
  document.addEventListener('change', function (e) {
	var fake = getFakeSelect();
	if (!fake || e.target !== fake) return;

	var real = getRealSelect();

	// Update the hidden S&F sort field
	if (real) {
	  real.value = fake.value;
	}

	// Update URL params and reload
	try {
	  var url = new URL(window.location.href);
	  var val = fake.value;

	  if (val) {
		url.searchParams.set('sort_order', val);
		// REMOVE this line:
		// url.searchParams.set('_sf_sort_order[]', val);
	  } else {
		url.searchParams.delete('sort_order');
		url.searchParams.delete('_sf_sort_order[]'); // you can keep this delete as cleanup
	  }

	  window.location.href = url.toString();
	} catch (e) {
	  // Fallback if URL API not supported
	  var href = window.location.href;
	  // Remove existing sort params
	  href = href.replace(/([?&])sort_order=[^&]*/g, '$1')
				 .replace(/([?&])_sf_sort_order\[\]=[^&]*/g, '$1')
				 .replace(/[?&]$/, '');

	  if (fake.value) {
		var sep = href.indexOf('?') === -1 ? '?' : '&';
		href += sep + 'sort_order=' + encodeURIComponent(fake.value)
				   + '&_sf_sort_order%5B%5D=' + encodeURIComponent(fake.value);
	  }

	  window.location.href = href;
	}
  });
});



// EXPANDER
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.expander').forEach((wrap) => {
	const limit  = parseInt(wrap.dataset.limit || '100', 10);
	const textEl = wrap.querySelector('.expander-text');
	const btn    = wrap.querySelector('.expander-btn');
	if (!textEl) return;

	// Keep the original HTML (links etc.) before we touch anything
	const originalHtml = textEl.innerHTML.trim();
	const plainLength  = (textEl.textContent || '').replace(/\s+/g, ' ').trim().length;

	// No "See More" button (no summary) -> leave as-is
	if (!btn) {
	  textEl.style.maxHeight = 'none';
	  return;
	}
	// Short enough -> hide "See More" but show View Source
	if (plainLength <= limit) {
	  btn.style.display = 'none';
	  wrap.classList.add('no-toggle', 'is-expanded');
	  textEl.style.maxHeight = 'none';
	  return;
	}

	const { preview, rest } = truncateHtml(originalHtml, limit);

	textEl.innerHTML =
	  `<span class="preview">${preview}</span>` +
	  `<span class="dots">...</span>` +
	  `<span class="more">${rest}</span>`;

	setState(wrap, false);
	measureAndStoreHeights(wrap);

	btn.addEventListener('click', () => {
	  const isExpanded = btn.getAttribute('aria-expanded') === 'true';
	  isExpanded ? collapse(wrap) : expand(wrap);
	});
  });

  window.addEventListener('resize', debounce(() => {
	document.querySelectorAll('.expander').forEach((wrap) => {
	  if (!wrap.querySelector('.expander-btn')) return;
	  measureAndStoreHeights(wrap);
	});
  }, 150));

  function expand(wrap) {
	const textEl = wrap.querySelector('.expander-text');
	textEl.style.maxHeight = wrap.dataset.collapsedH + 'px';
	requestAnimationFrame(() => {
	  setState(wrap, true);
	  textEl.style.maxHeight = wrap.dataset.expandedH + 'px';
	});
  }

  function collapse(wrap) {
	const textEl = wrap.querySelector('.expander-text');
	textEl.style.maxHeight = wrap.dataset.expandedH + 'px';
	requestAnimationFrame(() => {
	  setState(wrap, false);
	  textEl.style.maxHeight = wrap.dataset.collapsedH + 'px';
	});
  }

  function setState(wrap, expanded) {
	const textEl = wrap.querySelector('.expander-text');
	const btn = wrap.querySelector('.expander-btn');
	wrap.classList.toggle('is-expanded', expanded);
	textEl.classList.toggle('is-expanded', expanded);
	btn.classList.toggle('is-active', expanded);
	btn.setAttribute('aria-expanded', String(expanded));
	btn.textContent = expanded ? 'See Less' : 'See More';
  }

  function measureAndStoreHeights(wrap) {
	const textEl = wrap.querySelector('.expander-text');
	const btn = wrap.querySelector('.expander-btn');
	if (!textEl || !btn) return;
	const expandedNow = btn.getAttribute('aria-expanded') === 'true';
	textEl.classList.remove('is-expanded');
	textEl.style.maxHeight = 'none';
	const collapsedH = textEl.scrollHeight;
	textEl.classList.add('is-expanded');
	const expandedH = textEl.scrollHeight;
	textEl.classList.toggle('is-expanded', expandedNow);
	wrap.dataset.collapsedH = collapsedH;
	wrap.dataset.expandedH  = expandedH;
	textEl.style.maxHeight = expandedNow ? expandedH + 'px' : collapsedH + 'px';
  }

  function debounce(fn, wait) {
	let t;
	return (...args) => {
	  clearTimeout(t);
	  t = setTimeout(() => fn.apply(null, args), wait);
	};
  }

  // ---- HTML-aware truncation (preserves tags like <a>) ----

  function truncateHtml(html, limit) {
	const container = document.createElement('div');
	container.innerHTML = html;
	const counter = { count: 0 };
	const result = splitHtml(container, limit, counter);
	return { preview: result.preview, rest: result.rest, wasTruncated: result.splitDone };
  }

  function splitHtml(node, limit, counter) {
	let preview = '';
	let rest = '';
	let splitDone = false;

	for (const child of Array.from(node.childNodes)) {
	  if (splitDone) {
		// Everything after the cut point is untouched, keep it as real HTML
		rest += nodeOuterHtml(child);
		continue;
	  }

	  if (child.nodeType === Node.TEXT_NODE) {
		const text = child.textContent;
		if (counter.count + text.length <= limit) {
		  preview += escapeText(text);
		  counter.count += text.length;
		} else {
		  const remaining = limit - counter.count;
		  let cut = text.lastIndexOf(' ', remaining);
		  if (cut < 1) cut = remaining;
		  preview += escapeText(text.slice(0, cut));
		  rest += escapeText(text.slice(cut));
		  counter.count = limit;
		  splitDone = true;
		}
	  } else if (child.nodeType === Node.ELEMENT_NODE) {
		const tagName = child.tagName.toLowerCase();
		const attrs   = attrString(child);
		const open    = `<${tagName}${attrs}>`;
		const close   = `</${tagName}>`;

		const childResult = splitHtml(child, limit, counter);
		preview += open + childResult.preview + close;

		if (childResult.splitDone) {
		  // Cut happened inside this element (e.g. mid-link) — reopen it in "rest"
		  rest += open + childResult.rest + close;
		  splitDone = true;
		}
	  }
	}

	return { preview, rest, splitDone };
  }

  function nodeOuterHtml(node) {
	if (node.nodeType === Node.TEXT_NODE) return escapeText(node.textContent);
	if (node.nodeType === Node.ELEMENT_NODE) return node.outerHTML;
	return '';
  }

  function attrString(el) {
	return Array.from(el.attributes)
	  .map((a) => ` ${a.name}="${escapeAttr(a.value)}"`)
	  .join('');
  }

  function escapeText(str) {
	return String(str).replace(/[&<>"']/g, (m) => ({
	  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
	}[m]));
  }

  function escapeAttr(str) {
	return escapeText(str);
  }
});